// eslint-disable-next-line import/prefer-default-export
export const PolicyActionTypes = {
  SET_POLICY: 'SET_POLICY',
};
